import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  Input,
  Label,
  Hint,
  Heading,
  Tooltip,
  TooltipButton,
  Alert,
  GlyphInfo,
  Select as NormalSelect,
  SelectOption,
  Checkbox,
  Anchor,
} from "@americanexpress/dls-react";
import UkUpload from "../Import/UkUpload";

const UKForm = (props) => {
  const { t } = useTranslation("common");

  const {
    language,
    submit,
    getDetails,
    modifyUser,
    user,
    updateSavobj,
    error,
    invalidYear,
    handleNameProofCheckbox,
    handleEEAProofCheckbox,
    onChangeTitle,
    getFile,
    getEeaFile,
    mailext,
  } = props;

  const {
    title,
    titleOthers,
    firstName,
    fullMiddleName,
    lastName,
    modifyFirstName,
    modifyMiddleName,
    modifyLastName,
    paAddress,
    paPostcode,
    phoneNumber,
    emailId,
    modifyEmail,
    day,
    month,
    year,
    countryUK,
    paCountry,
    paExistingInfo,
    motherMaidenName,
    nationality,
    verificationPinUK,
    memorableDate,
    clueMemorableDate,
    bussRegName,
    bussRegAddress,
    bussRegPostcode,
    bussRegCountry,
    empBussName,
    corrAddress,
    corrPostcode,
    corrCountry,
    showOtherTitle,
    showCheckBox,
    modifyCheckBox,
    supportingFiles,
    globalDataTransFiles,
    eeaCheckbox,
    selfenroll,
  } = user;

  const paCountryList = [
    "USA",
    "Canada",
    "Argentina",
    "Mexico",
    "GDC",
    "Australia",
    "Hong Kong",
    "Singapore",
    "India",
    "New Zealand",
    "Japan",
    "Thailand",
    "Taiwan",
    "United Kingdom",
    "France",
    "Italy",
    "Spain",
    "Austria",
    "Netherlands",
    "IEC",
    "Czech Rep",
    "Hungary",
    "Poland",
    "Germany",
    "Belgium",
    "Denmark",
    "Sweden",
    "Norway",
    "Finland",
  ];

  let valueTitle = title;
  let titleUK = {
    value: valueTitle,
    label: <div>{valueTitle}</div>,
  };

  const titleOptions = [
    // { value: "", label: "" },
    {
      value: "Mr",
      label: <div>Mr</div>,
    },
    {
      value: "Mrs",
      label: <div>Mrs</div>,
    },
    {
      value: "Ms",
      label: <div>Ms</div>,
    },
    {
      value: "Miss",
      label: <div>Miss</div>,
    },
    {
      value: "Others",
      label: <div>Others</div>,
    },
  ];

  return (
    <>
      <div id="country-uk-modify">

        {eeaCheckbox && (
          <div className="row pad-1-t">
            <div className="col-xs-12 pad-2-b">
              <p>After completing, please upload Global Data Transfer Form:</p>
              <UkUpload
                getFileUk={(fileUk) =>
                  getEeaFile("globalDataTransFiles", fileUk)
                }
                filesUk={globalDataTransFiles}
              ></UkUpload>

              {globalDataTransFiles.length === 0 && eeaCheckbox && (
                <Alert status="error">Please upload file</Alert>
              )}
            </div>
          </div>
        )}

        <div className="row">
          {selfenroll === "2" && (
            <div className="col-xs-12">
              <Hint className="legal-1 pad-1-b">
                <b>United Kingdom: </b>
                {t("newUserUK.UKSetUpText")}
              </Hint>
            </div>
          )}
        </div>

        {/* UK ADD JOURNEY SECTION STARTS */}
        {!modifyUser && (
          <div id="country-uk-add">
            <section id="personal-info">
              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={4}
                    className="heading-4 dls-deep-blue pad-2-b"
                  >
                    {t("newUserUK.personalInfoHeading")}
                  </Heading>
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="title" id="title">
                    {t("newUserUK.title")}
                  </Label>

                  <Select
                    id="title"
                    className="select-country-dropdown"
                    placeholder="Title"
                    options={titleOptions}
                    value={titleUK}
                    onChange={(event) => {
                      updateSavobj("title", event.value);
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        border: "1px solid #C8C9C7",
                        height: "50px",
                        background: "#F7F8F9",
                        boxShadow: "none",
                        "&:hover": {
                          border: "1px solid #C8C9C7",
                        },
                      }),
                    }}
                  />

                  {submit && title === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.title")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && title === "" && language === "jap" && (
                    <Alert status="error">
                      {t("newUserUK.title")} {t("newUserUK.required")}
                    </Alert>
                  )}
                </div>

                {showOtherTitle && (
                  <div className="col-md-4 col-xs-12 pad-2-b">
                    <Label htmlFor="titleOthers"> &nbsp;</Label>
                    <Input
                      id="titleOthers"
                      type="text"
                      value={titleOthers}
                      onChange={(event) => {
                        onChangeTitle("titleOthers", event.target.value);
                      }}
                    />
                    {submit && title === "Others" && titleOthers === "" && (
                      <Alert status="error">Value Required</Alert>
                    )}
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="fullFirstName" id="fullFirstName">
                    {t("newUserUK.fullFirstName")}
                  </Label>
                  <Input
                    id="fullFirstName"
                    type="text"
                    value={firstName}
                    onChange={(event) => {
                      updateSavobj("firstName", event.target.value);
                    }}
                  />

                  {submit && firstName === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.fullFirstName")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && firstName === "" && language === "jap" && (
                    <Alert status="error">
                      {t("newUserUK.fullFirstName")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {language === "en" && !firstName.match(/^[a-zA-Z -]*$/) && (
                    <Alert status="error">{t("newuser.fnerror")}</Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="fullMiddleName" id="fullMiddleName">
                    {t("newUserUK.fullMiddleName")}
                  </Label>
                  <Input
                    id="fullMiddleName"
                    type="text"
                    value={fullMiddleName}
                    onChange={(event) => {
                      updateSavobj("fullMiddleName", event.target.value);
                    }}
                  />
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label>{t("newUserUK.fullLastName")}</Label>
                  <Input
                    value={lastName}
                    onChange={(event) => {
                      updateSavobj("lastName", event.target.value);
                    }}
                  />
                  {submit && lastName === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.fullLastName")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && lastName === "" && language === "jap" && (
                    <Alert status="error">
                      {t("newuser.lastNameRequired")}
                    </Alert>
                  )}
                  {language === "en" && !lastName.match(/^[a-zA-Z -]*$/) && (
                    <Alert status="error">
                      {t("newUserUK.fullLastNameError")}
                    </Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label>{t("newUserUK.paResAdd")}</Label>
                  <Input
                    value={paAddress}
                    onChange={(event) => {
                      updateSavobj("paAddress", event.target.value);
                    }}
                  />
                  {submit && paAddress === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.paResAdd")} {t("newUserUK.required")}
                    </Alert>
                  )}

                  {submit && paAddress === "" && language === "jap" && (
                    <Alert status="error">
                      PA Residential Address Required
                    </Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label>{t("newUserUK.postCode")}</Label>
                  <Input
                    value={paPostcode}
                    onChange={(event) => {
                      updateSavobj("paPostcode", event.target.value);
                    }}
                  />
                  {submit && paPostcode === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.postCode")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && paPostcode === "" && language === "jap" && (
                    <Alert status="error">{t("newuser.zipRequired")}</Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="countryUK">{t("newUserUK.countryUK")}</Label>
                  <Input
                    id="countryUK"
                    value={countryUK}
                    type="text"
                    onChange={(event) => {
                      updateSavobj("countryUK", event.target.value);
                    }}
                  />
                  {submit && countryUK === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.countryUK")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && countryUK === "" && language === "jap" && (
                    <Alert status="error">Country Required</Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b paCountriesList">
                  <Label htmlFor="paCountry">
                    {t("newUserUK.paCountryForLang")}
                  </Label>

                  <NormalSelect
                    id="paCountry"
                    value={paCountry}
                    onChange={(event) => {
                      updateSavobj("paCountry", event.target.value);
                    }}
                  >
                    <SelectOption value="" />
                    {paCountryList.map((country) => (
                      <SelectOption value={country} data-label={country}>
                        {country}
                      </SelectOption>
                    ))}
                  </NormalSelect>

                  {submit && paCountry === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.paCountryForLang")} {t("newUserUK.required")}
                    </Alert>
                  )}

                  {submit && paCountry === "" && language === "jap" && (
                    <Alert status="error">
                      PA Primary Country for Preferred Language Required
                    </Alert>
                  )}

                  <Hint className="legal-1">
                    {t("newUserUK.paCountryForLangInfo")}
                  </Hint>
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="paExistingInfo">
                    {t("newUserUK.paExitInfo")}
                  </Label>

                  <Input
                    id="paExistingInfo"
                    value={paExistingInfo}
                    onChange={(event) => {
                      updateSavobj("paExistingInfo", event.target.value);
                    }}
                  />

                  <Hint className="legal-1">
                    {t("newUserUK.paExitInfoTip")}
                  </Hint>
                </div>
              </div>
            </section>

            <hr />

            <section id="PA-screening">
              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={4}
                    className="heading-4 dls-deep-blue pad-2-t pad-2-b"
                  >
                    {t("newUserUK.newPAInfoForScreening")}
                  </Heading>
                </div>
              </div>

              <div className="row">
                <div className="col-md-2 col-xs-12 pad-2-b">
                  <Label className="label-3" htmlFor="dayUK">
                    {t("newUserUK.day")}
                  </Label>
                  <Input
                    id="dayUK"
                    placeholder={"DD"}
                    value={day}
                    onChange={(event) => {
                      updateSavobj("day", event.target.value);
                    }}
                    maxLength="2"
                  />
                  {submit && day === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.day")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && day === "" && language === "jap" && (
                    <Alert status="error">
                      {t("newuser.dateofBirthRequired")}
                    </Alert>
                  )}

                  {(!day.match(/^[0-9]*$/) ||
                    day.length > 2 ||
                    parseInt(day) > 31 ||
                    parseInt(day) <= 0) && (
                      <Alert status="error">{t("newUserUK.dayValid")}</Alert>
                    )}
                </div>

                <div className="col-md-2 col-xs-12 pad-2-b">
                  <Label htmlFor="monthUK">{t("newUserUK.month")}</Label>
                  <Input
                    id="monthUK"
                    placeholder={"MM"}
                    value={month}
                    onChange={(event) => {
                      updateSavobj("month", event.target.value);
                    }}
                    maxLength="2"
                  />

                  {submit && month === "" && language === "jap" && (
                    <Alert status="error">
                      {t("newuser.monthofBirthRequired")}
                    </Alert>
                  )}
                  {submit && month === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.month")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {(!month.match(/^[0-9]*$/) ||
                    month.length > 2 ||
                    parseInt(month) > 12 ||
                    month === "00") && (
                      <Alert status="error">{t("newUserUK.monthvalid")}</Alert>
                    )}
                </div>

                <div className="col-md-2 col-xs-12 pad-2-b">
                  <Label htmlFor="yearUK">{t("newUserUK.year")}</Label>
                  <Input
                    id="yearUK"
                    type="number"
                    placeholder={"YYYY"}
                    value={year}
                    onChange={(event) => {
                      updateSavobj("year", event.target.value);
                    }}
                    maxLength="4"
                  />

                  {submit && year === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.year")} {t("newUserUK.required")}
                    </Alert>
                  )}

                  {submit && year === "" && language === "jap" && (
                    <Alert status="error">
                      {t("newuser.yearofBirthRequired")}
                    </Alert>
                  )}

                  {(invalidYear &&
                    <Alert status="error">
                      {t("newUserUK.validYear")}
                    </Alert>
                  )}
                </div>

                <div className="col-md-3 col-xs-12 pad-2-b">
                  <Label htmlFor="nationality">
                    {t("newUserUK.nationality")}
                  </Label>
                  <Input
                    type="text"
                    id="nationality"
                    value={nationality}
                    onChange={(event) => {
                      updateSavobj("nationality", event.target.value);
                    }}
                  />
                  {submit && nationality === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.nationality")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && nationality === "" && language === "jap" && (
                    <Alert status="error">Nationality Required</Alert>
                  )}
                </div>
              </div>
            </section>

            <hr />

            <section id="PA-security-login">
              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={4}
                    className="heading-4 dls-deep-blue pad-2-t pad-2-b"
                  >
                    {t("newUserUK.newPASecurityForLogin")}
                  </Heading>
                </div>
              </div>

              <div className="row">
                <div className="col-md-3 col-xs-12 pad-2-b">
                  <Label htmlFor="motherMaidenName">
                    {t("newUserUK.motherMaidenName")}
                  </Label>
                  <Input
                    type="text"
                    id="motherMaidenName"
                    value={motherMaidenName}
                    onChange={(event) => {
                      updateSavobj("motherMaidenName", event.target.value);
                    }}
                  />
                  {submit && motherMaidenName === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.motherMaidenName")}{" "}
                      {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && motherMaidenName === "" && language === "jap" && (
                    <Alert status="error">Mother Maiden Name Required</Alert>
                  )}
                </div>

                <div className="col-md-3 col-xs-12 pad-2-b toolTipField">
                  <Label htmlFor="verificationPinUK">
                    {t("newUserUK.verificationPin")}
                  </Label>
                  <Input
                    id="verificationPinUK"
                    value={verificationPinUK}
                    maxLength="4"
                    onChange={(event) => {
                      updateSavobj("verificationPinUK", event.target.value);
                    }}
                  />

                  {submit && verificationPinUK === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.verificationPin")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && verificationPinUK === "" && language === "jap" && (
                    <Alert status="error">Verification Pin Required</Alert>
                  )}

                  {(!verificationPinUK.match(/^[0-9]*$/) ||
                    (verificationPinUK.length > 0 &&
                      verificationPinUK.length < 4)) && (
                      <Alert status="error">
                        {t("newUserUK.verificationPinValid")}
                      </Alert>
                    )}

                  <span className="infoTooltip">
                    <Tooltip
                      id="tooltip-default-top"
                      triggerElement={
                        <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                      }
                      placement="left"
                    >
                      <div>{t("newUserUK.verificationPinTooltip")}</div>
                    </Tooltip>
                  </span>

                  <Hint className="legal-1">
                    {t("newUserUK.verificationPinInfo")}
                  </Hint>
                </div>

                <div className="col-md-3 col-xs-12 pad-2-b toolTipField">
                  <Label htmlFor="memorableDate">
                    {t("newUserUK.memorableDate")}
                  </Label>
                  <Input
                    id="memorableDate"
                    value={memorableDate}
                    maxLength="4"
                    onChange={(event) => {
                      updateSavobj("memorableDate", event.target.value);
                    }}
                  />

                  {submit && memorableDate === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.memorableDate")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && memorableDate === "" && language === "jap" && (
                    <Alert status="error">Memorable Date Required</Alert>
                  )}

                  {(!memorableDate.match(/^[0-9]*$/) ||
                    (memorableDate.length > 0 && memorableDate.length < 4)) && (
                      <Alert status="error">
                        {t("newUserUK.verificationPinValid")}
                      </Alert>
                    )}

                  <span className="infoTooltip">
                    <Tooltip
                      id="tooltip-default-top"
                      triggerElement={
                        <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                      }
                      placement="left"
                    >
                      <div>{t("newUserUK.memorableDateTooltip")}</div>
                    </Tooltip>
                  </span>
                </div>

                <div className="col-md-3 col-xs-12 pad-2-b">
                  <Label htmlFor="clueMemorableDate">
                    {t("newUserUK.cMemorableDate")}
                  </Label>
                  <Input
                    type="text"
                    id="clueMemorableDate"
                    value={clueMemorableDate}
                    onChange={(event) => {
                      updateSavobj("clueMemorableDate", event.target.value);
                    }}
                  />
                  {submit && clueMemorableDate === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.cMemorableDate")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && clueMemorableDate === "" && language === "jap" && (
                    <Alert status="error">
                      Clue to Memorable Date Required
                    </Alert>
                  )}
                </div>
              </div>
            </section>

            <hr />

            <section id="contact-info">
              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={4}
                    className="heading-4 dls-deep-blue pad-2-t pad-2-b"
                  >
                    {t("newUserUK.contactInfoHeading")}
                  </Heading>
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label>{t("newUserUK.companyTelphoneNumber")}</Label>
                  <Input
                    value={phoneNumber}
                    onChange={(event) => {
                      updateSavobj("phoneNumber", event.target.value);
                    }}
                  />
                  <Hint>Include Country Code and Area Code</Hint>
                  {submit && phoneNumber === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.companyTelphoneNumber")}{" "}
                      {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && phoneNumber === "" && language === "jap" && (
                    <Alert status="error">
                      {t("newuser.phoneNumberRequired")}
                    </Alert>
                  )}
                  {!phoneNumber.match(/^[0-9+-]*$/) && (
                    <Alert status="error">{t("newUserUK.phoneError")} </Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label> {t("newUserUK.email")}</Label>
                  <Input
                    value={emailId}
                    onChange={(event) => {
                      updateSavobj("emailId", event.target.value);
                    }}
                    onBlur={getDetails}
                  />

                  {submit && emailId === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.email")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && emailId === "" && language === "jap" && (
                    <Alert status="error">{t("newuser.emailRequired")}</Alert>
                  )}
                  <Hint>{t("newUserUK.emailInfo")}</Hint>
                  {language === "en" &&
                    emailId !== "" &&
                    (error || submit) &&
                    mailext !== undefined &&
                    emailId.substring(emailId.indexOf("@") + 1) !== mailext && (
                      <Alert>
                        Users should belong to the same company for multi-user
                        submission
                      </Alert>
                    )}
                  {language === "en"
                    ? emailId !== "" &&
                    (error || submit) &&
                    !emailId.match(
                      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*$/
                      //  /^[a-zA-Z0-9.]+[-._a-z]+@[a-zA-Z0-9-_]+\.[a-zA-Z.-_]+$/
                    ) && (
                      <Alert status="error">
                        {t("newUserUK.emailError")}
                      </Alert>
                    )
                    : null}
                </div>
              </div>
            </section>

            <hr />

            <section id="company-info">
              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={4}
                    className="heading-4 dls-deep-blue pad-2-t pad-2-b"
                  >
                    {t("newUserUK.companyInfoHeading")}
                  </Heading>
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="bussRegName">Company Registered Name</Label>
                  <Input
                    type="text"
                    id="bussRegName"
                    value={bussRegName}
                    onChange={(event) => {
                      updateSavobj("bussRegName", event.target.value);
                    }}
                  />
                  {submit && bussRegName === "" && language === "en" && (
                    <Alert status="error">
                      Company Registered Name Required
                    </Alert>
                  )}
                  {submit && bussRegName === "" && language === "jap" && (
                    <Alert status="error">
                      Company Registered Name Required
                    </Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="bussRegAddress">
                    Company Registered Address
                  </Label>
                  <Input
                    type="text"
                    id="bussRegAddress"
                    value={bussRegAddress}
                    onChange={(event) => {
                      updateSavobj("bussRegAddress", event.target.value);
                    }}
                  />
                  {submit && bussRegAddress === "" && language === "en" && (
                    <Alert status="error">
                      Company Registered Address Required
                    </Alert>
                  )}
                  {submit && bussRegAddress === "" && language === "jap" && (
                    <Alert status="error">
                      Company Registered Address Required
                    </Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="bussRegPostcode">
                    Company Registered Postal Code
                  </Label>
                  <Input
                    type="text"
                    id="bussRegPostcode"
                    value={bussRegPostcode}
                    onChange={(event) => {
                      updateSavobj("bussRegPostcode", event.target.value);
                    }}
                  />
                  {submit && bussRegPostcode === "" && language === "en" && (
                    <Alert status="error">
                      Company Registered Postal Code Required
                    </Alert>
                  )}
                  {submit && bussRegPostcode === "" && language === "jap" && (
                    <Alert status="error">
                      Company Registered Postal Code Required
                    </Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="bussRegCountry">
                    Company Registered Country
                  </Label>
                  <Input
                    type="text"
                    id="bussRegCountry"
                    value={bussRegCountry}
                    onChange={(event) => {
                      updateSavobj("bussRegCountry", event.target.value);
                    }}
                  />
                  {submit && bussRegCountry === "" && language === "en" && (
                    <Alert status="error">
                      Company Registered Country Required
                    </Alert>
                  )}
                  {submit && bussRegCountry === "" && language === "jap" && (
                    <Alert status="error">
                      Company Registered Country Required
                    </Alert>
                  )}
                </div>
              </div>
            </section>

            <section className="correspondence-info">
              <div className="row">
                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="empBussName">Employer Company Name</Label>
                  <Input
                    type="text"
                    id="empBussName"
                    value={empBussName}
                    onChange={(event) => {
                      updateSavobj("empBussName", event.target.value);
                    }}
                  />
                  <Hint className="legal-1">
                    Provide if different than Registered Name
                  </Hint>
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="corrAddress">Correspondence Address</Label>
                  <Input
                    type="text"
                    id="corrAddress"
                    value={corrAddress}
                    onChange={(event) => {
                      updateSavobj("corrAddress", event.target.value);
                    }}
                  />
                  <Hint className="legal-1">
                    Provide if different than Registered Address
                  </Hint>
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="corrPostcode">
                    Correspondence Postal Code
                  </Label>
                  <Input
                    type="text"
                    id="corrPostcode"
                    value={corrPostcode}
                    onChange={(event) => {
                      updateSavobj("corrPostcode", event.target.value);
                    }}
                  />
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="corrCountry">Correspondence Country</Label>
                  <Input
                    type="text"
                    id="corrCountry"
                    value={corrCountry}
                    onChange={(event) => {
                      updateSavobj("corrCountry", event.target.value);
                    }}
                  />
                </div>
              </div>
            </section>
          </div>
        )}
        {/* END OF UK ADD JOURNEY SECTION */}

        {/* UK MODIFY JOURNEY SECTION STARTS */}
        {modifyUser && (
          <div id="country-uk-modify">
            <section id="current-user-details">
              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={4}
                    className="heading-4 dls-deep-blue pad-2-b"
                  >
                    {t("newUserUK.currentUserHeading")}
                  </Heading>
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="fullFirstName" id="fullFirstName">
                    {t("newUserUK.fullFirstName")}
                  </Label>
                  <Input
                    id="fullFirstName"
                    type="text"
                    value={firstName}
                    onChange={(event) => {
                      updateSavobj("firstName", event.target.value);
                    }}
                  />

                  {submit && firstName === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.fullFirstName")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && firstName === "" && language === "jap" && (
                    <Alert status="error">
                      {t("newUserUK.fullFirstName")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {language === "en" && !firstName.match(/^[a-zA-Z -]*$/) && (
                    <Alert status="error">{t("newuser.fnerror")}</Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="fullMiddleName" id="fullMiddleName">
                    {t("newUserUK.fullMiddleName")}
                  </Label>
                  <Input
                    id="fullMiddleName"
                    type="text"
                    value={fullMiddleName}
                    onChange={(event) => {
                      updateSavobj("fullMiddleName", event.target.value);
                    }}
                  />

                  {language === "en" &&
                    !fullMiddleName.match(/^[a-zA-Z -]*$/) && (
                      <Alert status="error">{t("newuser.fnerror")}</Alert>
                    )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label>{t("newUserUK.fullLastName")}</Label>
                  <Input
                    value={lastName}
                    onChange={(event) => {
                      updateSavobj("lastName", event.target.value);
                    }}
                  />
                  {submit && lastName === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.fullLastName")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && lastName === "" && language === "jap" && (
                    <Alert status="error">
                      {t("newuser.lastNameRequired")}
                    </Alert>
                  )}
                  {language === "en" && !lastName.match(/^[a-zA-Z -]*$/) && (
                    <Alert status="error">
                      {t("newUserUK.fullLastNameError")}
                    </Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label className="label-3">{t("newUserUK.email")}</Label>
                  <Input
                    value={emailId}
                    onChange={(event) => {
                      updateSavobj("emailId", event.target.value);
                    }}
                    onBlur={getDetails}
                  />
                  <Hint>{t("newUserUK.emailInfo")}</Hint>

                  {submit && emailId === "" && language === "en" && (
                    <Alert status="error">
                      {t("newUserUK.email")} {t("newUserUK.required")}
                    </Alert>
                  )}
                  {submit && emailId === "" && language === "jap" && (
                    <Alert status="error">{t("newuser.emailRequired")}</Alert>
                  )}
                  {language === "en" &&
                    emailId !== "" &&
                    (error || submit) &&
                    mailext !== undefined &&
                    emailId.substring(emailId.indexOf("@") + 1) !== mailext && (
                      <Alert>
                        Users should belong to the same company for multi-user
                        submission
                      </Alert>
                    )}
                  {language === "en"
                    ? emailId !== "" &&
                    (error || submit) &&
                    !emailId.match(
                      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*$/
                      //  /^[a-zA-Z0-9.]+[-._a-z]+@[a-zA-Z0-9-_]+\.[a-zA-Z.-_]+$/
                    ) && (
                      <Alert status="error">
                        {t("newUserUK.emailError")}
                      </Alert>
                    )
                    : null}
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={4}
                    className="heading-4 dls-deep-blue pad-2-t pad-2-b"
                  >
                    Company Information
                  </Heading>
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="bussRegName">Company Registered Name</Label>
                  <Input
                    type="text"
                    id="bussRegName"
                    value={bussRegName}
                    onChange={(event) => {
                      updateSavobj("bussRegName", event.target.value);
                    }}
                  />

                  {submit && bussRegName === "" && language === "en" && (
                    <Alert status="error">
                      Company Registered Name Required
                    </Alert>
                  )}
                  {submit && bussRegName === "" && language === "jap" && (
                    <Alert status="error">
                      Company Registered Name Required
                    </Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="bussRegAddress">
                    Company Registered Address
                  </Label>
                  <Input
                    type="text"
                    id="bussRegAddress"
                    value={bussRegAddress}
                    onChange={(event) => {
                      updateSavobj("bussRegAddress", event.target.value);
                    }}
                  />
                  {submit && bussRegAddress === "" && language === "en" && (
                    <Alert status="error">
                      Company Registered Address Required
                    </Alert>
                  )}
                  {submit && bussRegAddress === "" && language === "jap" && (
                    <Alert status="error">
                      Company Registered Address Required
                    </Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="bussRegPostcode">
                    Company Registered Postal Code
                  </Label>
                  <Input
                    type="text"
                    id="bussRegPostcode"
                    value={bussRegPostcode}
                    onChange={(event) => {
                      updateSavobj("bussRegPostcode", event.target.value);
                    }}
                  />
                  {submit && bussRegPostcode === "" && language === "en" && (
                    <Alert status="error">
                      Company Registered Postal Code Required
                    </Alert>
                  )}
                  {submit && bussRegPostcode === "" && language === "jap" && (
                    <Alert status="error">
                      Company Registered Postal Code Required
                    </Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="bussRegCountry">
                    Company Registered Country
                  </Label>
                  <Input
                    type="text"
                    id="bussRegCountry"
                    value={bussRegCountry}
                    onChange={(event) => {
                      updateSavobj("bussRegCountry", event.target.value);
                    }}
                  />
                  {submit && bussRegCountry === "" && language === "en" && (
                    <Alert status="error">
                      Company Registered Country Required
                    </Alert>
                  )}
                  {submit && bussRegCountry === "" && language === "jap" && (
                    <Alert status="error">
                      Company Registered Country Required
                    </Alert>
                  )}
                </div>
              </div>
            </section>

            <hr />

            <section id="personal-info">
              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={4}
                    className="heading-4 dls-deep-blue pad-2-t pad-1-b"
                  >
                    Please Only Provide Details That Require Modifying for the
                    PA's Personal Information or Access
                  </Heading>

                  <Heading
                    level={5}
                    className="heading-5 dls-deep-blue pad-2-b"
                  >
                    {t("newUserUK.modifyPersonalHeading")}
                  </Heading>
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="title">{t("newUserUK.title")}</Label>

                  <Select
                    id="title"
                    className="select-country-dropdown"
                    placeholder="Title"
                    options={titleOptions}
                    value={titleUK}
                    onChange={(event) => {
                      updateSavobj("title", event.value);
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        border: "1px solid #C8C9C7",
                        height: "50px",
                        background: "#F7F8F9",
                        boxShadow: "none",
                        "&:hover": {
                          border: "1px solid #C8C9C7",
                        },
                      }),
                    }}
                  />
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  {showOtherTitle && (
                    <>
                      <Label htmlFor="titleOthers"> &nbsp;</Label>
                      <Input
                        id="titleOthers"
                        type="text"
                        value={titleOthers}
                        onChange={(event) => {
                          onChangeTitle("titleOthers", event.target.value);
                        }}
                      />
                      {submit && title === "Others" && titleOthers === "" && (
                        <Alert status="error">Value Required</Alert>
                      )}
                    </>
                  )}
                </div>

                {showCheckBox && (
                  <div className="col-md-4 col-xs-12 modifyNameProof pad-4-t">
                    <Checkbox
                      label="Upload document for name change"
                      id={Math.random()}
                      checked={modifyCheckBox}
                      onChange={handleNameProofCheckbox}
                      defaultChecked={false}
                    />

                    <div className="nameTooltip">
                      <Tooltip
                        id="tooltip-default-top"
                        triggerElement={
                          <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                        }
                        placement="left"
                      >
                        <div>
                          After checking this checkbox you will be able to
                          upload your supporting documents. You can check upload
                          placement at bottom of the page
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="modifyFirstName" id="modifyFirstName">
                    {t("newUserUK.fullFirstName")}
                  </Label>
                  <Input
                    id="modifyFirstName"
                    type="text"
                    value={modifyFirstName}
                    onChange={(event) => {
                      updateSavobj("modifyFirstName", event.target.value);
                    }}
                  />
                  {language === "en" &&
                    !modifyFirstName.match(/^[a-zA-Z -]*$/) && (
                      <Alert status="error">{t("newuser.fnerror")}</Alert>
                    )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="modifyMiddleName" id="modifyMiddleName">
                    {t("newUserUK.fullMiddleName")}
                  </Label>
                  <Input
                    id="modifyMiddleName"
                    type="text"
                    value={modifyMiddleName}
                    onChange={(event) => {
                      updateSavobj("modifyMiddleName", event.target.value);
                    }}
                  />
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="modifyLastName" id="modifyLastName">
                    {t("newUserUK.fullLastName")}
                  </Label>
                  <Input
                    id="modifyLastName"
                    value={modifyLastName}
                    onChange={(event) => {
                      updateSavobj("modifyLastName", event.target.value);
                    }}
                  />
                  {language === "en" &&
                    !modifyLastName.match(/^[a-zA-Z -]*$/) && (
                      <Alert status="error">{t("newuser.lnerror")}</Alert>
                    )}
                </div>

                {(modifyFirstName !== "" ||
                  modifyMiddleName !== "" ||
                  modifyLastName !== "") &&
                  !modifyCheckBox &&
                  supportingFiles.length == 0 && (
                    <div className="col-md-12 col-xs-12 pad-2-b">
                      <Alert status="error">
                        For name changes, please provide supporting
                        documentation i.e. marriage certificate or deed poll,
                        Just click on check box which is appearing above Last
                        Name
                      </Alert>
                    </div>
                  )}

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label>{t("newUserUK.paResAdd")}</Label>
                  <Input
                    value={paAddress}
                    onChange={(event) => {
                      updateSavobj("paAddress", event.target.value);
                    }}
                  />
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label>{t("newUserUK.postCode")}</Label>
                  <Input
                    value={paPostcode}
                    onChange={(event) => {
                      updateSavobj("paPostcode", event.target.value);
                    }}
                  />
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="countryUK">{t("newUserUK.countryUK")}</Label>
                  <Input
                    id="countryUK"
                    value={countryUK}
                    type="text"
                    onChange={(event) => {
                      updateSavobj("countryUK", event.target.value);
                    }}
                  />
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b paCountriesList">
                  <Label htmlFor="paCountry">
                    {t("newUserUK.paCountryForLang")}
                  </Label>
                  <NormalSelect
                    id="paCountry"
                    value={paCountry}
                    onChange={(event) => {
                      updateSavobj("paCountry", event.target.value);
                    }}
                  >
                    <SelectOption value="" />
                    {paCountryList.map((country) => (
                      <SelectOption value={country} data-label={country}>
                        {country}
                      </SelectOption>
                    ))}
                  </NormalSelect>
                  <Hint className="legal-1">
                    {t("newUserUK.paCountryForLangInfo")}
                  </Hint>
                </div>
              </div>
            </section>

            <hr />

            <section id="modify-pa-info-screening">
              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={4}
                    className="heading-4 dls-deep-blue pad-2-t pad-2-b"
                  >
                    {t("newUserUK.modifyPAInfoForScreening")}
                  </Heading>
                </div>
              </div>

              <div className="row">
                <div className="col-md-2 col-xs-12 pad-2-b">
                  <Label htmlFor="dayUK">{t("newUserUK.day")}</Label>
                  <Input
                    id="dayUK"
                    placeholder={"DD"}
                    value={day}
                    onChange={(event) => {
                      updateSavobj("day", event.target.value);
                    }}
                    maxLength="2"
                  />

                  {(!day.match(/^[0-9]*$/) ||
                    day.length > 2 ||
                    parseInt(day) > 31 ||
                    parseInt(day) <= 0) && (
                      <Alert status="error">{t("newUserUK.dayValid")}</Alert>
                    )}
                </div>

                <div className="col-md-2 col-xs-12 pad-2-b">
                  <Label htmlFor="monthUK">{t("newUserUK.month")}</Label>
                  <Input
                    id="monthUK"
                    placeholder={"MM"}
                    value={month}
                    onChange={(event) => {
                      updateSavobj("month", event.target.value);
                    }}
                    maxLength="2"
                  />
                  {(!month.match(/^[0-9]*$/) ||
                    month.length > 2 ||
                    parseInt(month) > 12 ||
                    month === "00") && (
                      <Alert status="error">{t("newUserUK.monthvalid")}</Alert>
                    )}
                </div>

                <div className="col-md-2 col-xs-12 pad-2-b">
                  <Label htmlFor="yearUK">{t("newUserUK.year")}</Label>
                  <Input
                    id="yearUK"
                    type="number"
                    placeholder={"YYYY"}
                    value={year}
                    onChange={(event) => {
                      updateSavobj("year", event.target.value);
                    }}
                    maxLength="4"
                  />
                  {invalidYear && (
                      <Alert status="error">
                        {t("newUserUK.validYear")}
                      </Alert>
                    )}
                </div>

                <div className="col-md-3 col-xs-12 pad-2-b">
                  <Label htmlFor="nationality">
                    {t("newUserUK.nationality")}
                  </Label>
                  <Input
                    type="text"
                    id="nationality"
                    value={nationality}
                    onChange={(event) => {
                      updateSavobj("nationality", event.target.value);
                    }}
                  />
                </div>
              </div>
            </section>

            <hr />

            <section id="modify-pa-info-security-login">
              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={4}
                    className="heading-4 dls-deep-blue pad-2-t pad-2-b"
                  >
                    {t("newUserUK.modifyPASecurityForLogin")}
                  </Heading>
                </div>
              </div>

              <div className="row">
                <div className="col-md-3 col-xs-12 pad-2-b">
                  <Label htmlFor="motherMaidenName">
                    {t("newUserUK.motherMaidenName")}
                  </Label>
                  <Input
                    type="text"
                    id="motherMaidenName"
                    value={motherMaidenName}
                    onChange={(event) => {
                      updateSavobj("motherMaidenName", event.target.value);
                    }}
                  />
                </div>

                <div className="col-md-3 col-xs-12 pad-2-b toolTipField">
                  <Label htmlFor="verificationPinUK">
                    {t("newUserUK.verificationPin")}
                  </Label>
                  <Input
                    id="verificationPinUK"
                    value={verificationPinUK}
                    maxLength="4"
                    onChange={(event) => {
                      updateSavobj("verificationPinUK", event.target.value);
                    }}
                  />

                  {(!verificationPinUK.match(/^[0-9]*$/) ||
                    (verificationPinUK.length > 0 &&
                      verificationPinUK.length < 4)) && (
                      <Alert status="error">
                        {t("newUserUK.verificationPinValid")}
                      </Alert>
                    )}

                  <span className="infoTooltip">
                    <Tooltip
                      id="tooltip-default-top"
                      triggerElement={
                        <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                      }
                      placement="left"
                    >
                      <div>{t("newUserUK.verificationPinTooltip")}</div>
                    </Tooltip>
                  </span>

                  <Hint className="legal-1">
                    {t("newUserUK.verificationPinInfo")}
                  </Hint>
                </div>

                <div className="col-md-3 col-xs-12 pad-2-b toolTipField">
                  <Label htmlFor="memorableDate">
                    {t("newUserUK.memorableDate")}
                  </Label>
                  <Input
                    id="memorableDate"
                    value={memorableDate}
                    maxLength="4"
                    onChange={(event) => {
                      updateSavobj("memorableDate", event.target.value);
                    }}
                  />

                  {(!memorableDate.match(/^[0-9]*$/) ||
                    (memorableDate.length > 0 && memorableDate.length < 4)) && (
                      <Alert status="error">
                        {t("newUserUK.verificationPinValid")}
                      </Alert>
                    )}

                  <span className="infoTooltip">
                    <Tooltip
                      id="tooltip-default-top"
                      triggerElement={
                        <TooltipButton icon={<GlyphInfo />} tabIndex="-1" />
                      }
                      placement="left"
                    >
                      <div>{t("newUserUK.memorableDateTooltip")}</div>
                    </Tooltip>
                  </span>
                </div>

                <div className="col-md-3 col-xs-12 pad-2-b">
                  <Label htmlFor="clueMemorableDate">
                    {t("newUserUK.cMemorableDate")}
                  </Label>
                  <Input
                    type="text"
                    id="clueMemorableDate"
                    value={clueMemorableDate}
                    onChange={(event) => {
                      updateSavobj("clueMemorableDate", event.target.value);
                    }}
                  />
                </div>
              </div>
            </section>

            <section id="contact-info">
              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={4}
                    className="heading-4 dls-deep-blue pad-2-t pad-2-b"
                  >
                    {t("newUserUK.ModifyContactInfoHeading")}
                  </Heading>
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="phoneNumber">
                    {t("newUserUK.companyTelphoneNumber")}
                  </Label>
                  <Input
                    value={phoneNumber}
                    onChange={(event) => {
                      updateSavobj("phoneNumber", event.target.value);
                    }}
                  />
                  <Hint>Include Country Code and Area Code</Hint>
                  {!phoneNumber.match(/^[0-9+-]*$/) && (
                    <Alert status="error">{t("newUserUK.phoneError")}</Alert>
                  )}
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="modifyEmail">{t("newUserUK.email")}</Label>
                  <Input
                    id="modifyEmail"
                    value={modifyEmail}
                    onChange={(event) => {
                      updateSavobj("modifyEmail", event.target.value);
                    }}
                    onBlur={getDetails}
                  />
                  <Hint>{t("newUserUK.emailInfo")}</Hint>

                  {language === "en" &&
                    modifyEmail !== "" &&
                    !modifyEmail.match(
                      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*$/
                    ) && (
                      <Alert status="error">{t("newUserUK.emailError")}</Alert>
                    )}
                </div>
              </div>
            </section>

            <section className="correspondence-info">
              <div className="row">
                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="corrAddress">Correspondence Address</Label>
                  <Input
                    type="text"
                    id="corrAddress"
                    value={corrAddress}
                    onChange={(event) => {
                      updateSavobj("corrAddress", event.target.value);
                    }}
                  />
                  <Hint className="legal-1">
                    Provide if different than Registered Address
                  </Hint>
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="corrPostcode">
                    Correspondence Postal Code
                  </Label>
                  <Input
                    type="text"
                    id="corrPostcode"
                    value={corrPostcode}
                    onChange={(event) => {
                      updateSavobj("corrPostcode", event.target.value);
                    }}
                  />
                </div>

                <div className="col-md-4 col-xs-12 pad-2-b">
                  <Label htmlFor="corrCountry">Correspondence Country</Label>
                  <Input
                    type="text"
                    id="corrCountry"
                    value={corrCountry}
                    onChange={(event) => {
                      updateSavobj("corrCountry", event.target.value);
                    }}
                  />
                </div>
              </div>
            </section>

            <hr />

            <section id="company-info">
              {modifyCheckBox && (
                <div className="row">
                  <div className="col-xs-12 pad-2-b">
                    <p>
                      For name changes, please provide supporting documentation
                      i.e. marriage certificate or deed poll.
                    </p>
                    <UkUpload
                      getFileUk={(fileUk) => getFile("supportingFiles", fileUk)}
                      filesUk={supportingFiles}
                    ></UkUpload>

                    {supportingFiles.length === 0 && modifyCheckBox && (
                      <Alert status="error">Please upload file</Alert>
                    )}
                  </div>
                </div>
              )}
            </section>
          </div>
        )}
        {/* END OF UK MODIFY JOURNEY SECTION */}
      </div>
    </>
  );
};

export default UKForm;
